import React, { useState } from 'react';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaPopup from '../../../Elements/figmaPopup';
import PopupTypesEnum from '../../../Enums/PopupTypesEnum';

function ConfirmDialogsDemoComponent() {
  const [lastAction, setLastAction] = useState('(none yet)');
  // Save/Select are FigmaPopup types with no ErrorMessage static shortcut, so the demo
  // mounts them directly and toggles them with local state.
  const [savePopupShown, setSavePopupShown] = useState(false);
  const [selectPopupShown, setSelectPopupShown] = useState(false);

  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>ErrorMessage static API</div>
      </div>
      <div className='dsg-row'>
        <button
          type='button'
          className='btn'
          onClick={() =>
            ErrorMessage.SetApprove(
              'Are you sure you want to delete this demo item?',
              () => setLastAction('Approve: OK clicked'),
              'Delete permanently',
              () => setLastAction('Approve: cancelled')
            )
          }
        >
          Approve (two buttons)
        </button>
        <button
          type='button'
          className='btn'
          onClick={() => ErrorMessage.SetWarning('Something needs your attention (demo).')}
        >
          Warning (one button)
        </button>
        <button
          type='button'
          className='btn'
          onClick={() =>
            ErrorMessage.SetWarningWithComment(
              'Please tell us why you are converting this demo item.',
              'Reason for converting',
              (reason) => setLastAction('Warning+comment: submitted "' + reason + '"'),
              'Send',
              'Cancel',
              true
            )
          }
        >
          Warning + comment
        </button>
        <button
          type='button'
          className='btn'
          onClick={() =>
            ErrorMessage.SetWarningWithComment(
              'This will re-run the demo export. Continue?',
              '',
              () => setLastAction('Warning 2-button: confirmed'),
              'Confirm',
              'Cancel',
              false
            )
          }
        >
          Warning (two buttons)
        </button>
        <button
          type='button'
          className='btn'
          onClick={() => ErrorMessage.SetSuccess('Demo item saved successfully.')}
        >
          Success
        </button>
        <button
          type='button'
          className='btn'
          onClick={() => ErrorMessage.SetInfo('For your information (demo).')}
        >
          Info
        </button>
      </div>

      <div className='dsg-row'>
        <div className='dsg-demo-label'>Direct FigmaPopup types (Save / Select)</div>
      </div>
      <div className='dsg-row'>
        <button
          type='button'
          className='btn'
          onClick={() => setSavePopupShown(true)}
        >
          Save (save-as input)
        </button>
        <button
          type='button'
          className='btn'
          onClick={() => setSelectPopupShown(true)}
        >
          Select (select-all)
        </button>
      </div>

      <p style={{ fontSize: 13, color: 'var(--ink-2)' }}>Last dialog result: {lastAction}</p>

      {savePopupShown ? (
        <FigmaPopup
          type={PopupTypesEnum.Save}
          overButtonText='Saving as'
          okButtonText='Save'
          cancelButtonText='Cancel'
          okPopupFunction={() => {
            setSavePopupShown(false);
            setLastAction('Save: saved');
          }}
          closePopupFunction={() => {
            setSavePopupShown(false);
            setLastAction('Save: cancelled');
          }}
        />
      ) : null}

      {selectPopupShown ? (
        <FigmaPopup
          type={PopupTypesEnum.Select}
          okButtonText='All'
          cancelButtonText='Cancel'
          pageCount={20}
          allCount={200}
          okPopupFunction={() => {
            setSelectPopupShown(false);
            setLastAction('Select: chosen');
          }}
          closePopupFunction={() => {
            setSelectPopupShown(false);
            setLastAction('Select: cancelled');
          }}
        />
      ) : null}
    </div>
  );
}

export const confirmDialogsDemo = {
  id: 'confirm-dialogs',
  title: 'Confirm & message dialogs',
  category: 'Overlays & Editing',
  importPath: 'Elements/ErrorMessage (static API over Elements/figmaPopup)',
  notes: [
    'Global static API — no mounting needed: ErrorMessage.SetApprove(msg, onOk, overButtonText?, onCancel?), SetWarning, SetWarningWithComment(msg, label, onSubmit, okText?, cancelText?, showComment?), SetSuccess, SetInfo, SetLoading(bool).',
    'SetApprove renders the two-button confirm (overButtonText is the heading above the buttons, default "DO YOU WANT TO CONTINUE?"); SetWarning is one-button; SetWarningWithComment renders a reason textarea (showComment=true) or a plain two-button warning (false).',
    'Save and Select are FigmaPopup types with no ErrorMessage shortcut — render <FigmaPopup type={PopupTypesEnum.Save|Select} .../> directly (the demo toggles them with local state).',
    'Backend TpException messages surface verbatim to users — pair clean exception text with these dialogs.',
  ],
  snippet:
    "ErrorMessage.SetApprove(\n  'Are you sure you want to delete this item?',\n  () => this.deleteItem(),\n  'Delete permanently'\n);",
  render: ConfirmDialogsDemoComponent,
};
